var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        [
          _c(
            "div",
            { staticClass: "page-container partner-manage-page" },
            [
              _c(
                "div",
                { staticClass: "query-form-wrap" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        model: _vm.form,
                        size: _vm.formSize,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "应用名称" },
                            model: {
                              value: _vm.form.appName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "appName", $$v)
                              },
                              expression: "form.appName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                loading: _vm.listLoading,
                                icon: "el-icon-search",
                                type: "primary",
                              },
                              on: { click: _vm.handleSearch },
                            },
                            [_vm._v("搜索")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "contenmanage_appconfig_add",
                              expression: "'contenmanage_appconfig_add'",
                            },
                          ],
                          attrs: {
                            icon: "el-icon-plus",
                            size: "small",
                            type: "primary",
                          },
                          on: { click: _vm.openEdit },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "contenmanage_appconfig_delete",
                              expression: "'contenmanage_appconfig_delete'",
                            },
                          ],
                          attrs: {
                            type: "danger",
                            icon: "el-icon-delete",
                            size: "small",
                          },
                          on: { click: _vm.batchDel },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    "cell-style": { "text-align": "center" },
                    "header-cell-style": { "text-align": "center" },
                    "max-height": _vm.tableHeight,
                    "element-loading-text": "加载中",
                    border: "",
                    data: _vm.tableDataList,
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      fixed: "",
                      label: "ID",
                      align: "center",
                      "header-align": "center",
                      width: "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "appName",
                      align: "center",
                      "header-align": "center",
                      label: "应用名称",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "appLogo",
                      align: "center",
                      "header-align": "center",
                      label: "应用图标",
                      width: "200",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("img", {
                              attrs: { src: scope.row.appLogo, height: "30px" },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "androidPkg",
                      align: "center",
                      "header-align": "center",
                      label: "安卓包名",
                      width: "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "androidSchema",
                      align: "center",
                      "header-align": "center",
                      label: "安卓Schema",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "androidDownloadUrl",
                      align: "center",
                      "header-align": "center",
                      label: "安卓下载地址",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "iosAppId",
                      align: "center",
                      "header-align": "center",
                      label: "iOS应用ID",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ios Schema",
                      align: "center",
                      "header-align": "center",
                      label: "iosSchema",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "updateUserName",
                      align: "center",
                      "header-align": "center",
                      label: "修改人",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "updateTime",
                      align: "center",
                      "header-align": "center",
                      width: "150",
                      label: "修改时间",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "200", fixed: "right", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.reviewStatus != 1 &&
                            scope.row.reviewStatus != 3
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: "contenmanage_appconfig_update",
                                        expression:
                                          "'contenmanage_appconfig_update'",
                                      },
                                    ],
                                    attrs: {
                                      icon: "el-icon-edit",
                                      size: "small",
                                      type: "text",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEdit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-pagination" },
                [
                  _c("TablePagination", {
                    attrs: {
                      "page-size": _vm.pageConfig.size,
                      total: _vm.total,
                      "current-page": _vm.pageConfig.current,
                    },
                    on: {
                      "update:pageSize": function ($event) {
                        return _vm.$set(_vm.pageConfig, "size", $event)
                      },
                      "update:page-size": function ($event) {
                        return _vm.$set(_vm.pageConfig, "size", $event)
                      },
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.pageConfig, "current", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.pageConfig, "current", $event)
                      },
                      change: _vm.handlePageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.checkItem.id ? "修改" : "新增",
                visible: _vm.showEdit,
                "append-to-body": "",
                width: "40%",
                "before-close": _vm.handleAddOrEditClose,
                top: "5vh",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showEdit = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.checkItem,
                    "label-width": "80px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用名称", prop: "appName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入应用名称" },
                        model: {
                          value: _vm.checkItem.appName,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "appName", $$v)
                          },
                          expression: "checkItem.appName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "fileAppLogoRule",
                      attrs: { label: "应用图标", prop: "appLogo" },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            action: "#",
                            "list-type": "picture-card",
                            "on-preview": _vm.handleImgsPreview,
                            "auto-upload": false,
                            "file-list": _vm.fileImgesList,
                            "on-exceed": _vm.uploadOnExceed,
                            "on-change": _vm.handleChangeImgs,
                            "on-remove": _vm.handleRemoveImgs,
                          },
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                      _c(
                        "el-dialog",
                        {
                          attrs: { visible: _vm.dialogImageVisible },
                          on: {
                            "update:visible": function ($event) {
                              _vm.dialogImageVisible = $event
                            },
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              src: _vm.checkItem.appLogo,
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "安卓配置" } }),
                  _c(
                    "el-form-item",
                    { attrs: { label: "包名" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入应用包名" },
                        model: {
                          value: _vm.checkItem.androidPkg,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "androidPkg", $$v)
                          },
                          expression: "checkItem.androidPkg",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "schema" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入应用schema" },
                        model: {
                          value: _vm.checkItem.androidSchema,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "androidSchema", $$v)
                          },
                          expression: "checkItem.androidSchema",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "下载地址" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入下载地址" },
                        model: {
                          value: _vm.checkItem.androidDownloadUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "androidDownloadUrl", $$v)
                          },
                          expression: "checkItem.androidDownloadUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "苹果配置" } }),
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用ID" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入应用ID" },
                        model: {
                          value: _vm.checkItem.iosAppId,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "iosAppId", $$v)
                          },
                          expression: "checkItem.iosAppId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "schema" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入应用schema" },
                        model: {
                          value: _vm.checkItem.iosSchema,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "iosSchema", $$v)
                          },
                          expression: "checkItem.iosSchema",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitChange("ruleForm")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-circle-close" },
                      on: { click: _vm.handleAddOrEditClose },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }